import { v4 } from 'uuid';

export const getNewGuid = v4;
